import { useMutation } from '@tanstack/react-query'
import { createThumbnail } from '../../service/list'

function useCreateThumbnailByPlacid() {
  return useMutation({
    mutationKey: ['create-thumbnail-placid'],
    mutationFn: createThumbnail,
  })
}

export default useCreateThumbnailByPlacid
